/**
 * <TutorStudentLastSessionCard> — la dernière séance de l'élève, dans son Aperçu (organism).
 *
 * « Dernière séance » de `StudentBriefSections.js` : son intitulé (« … en Mathématiques » quand l'élève
 * a plusieurs objectifs), sa date, les étiquettes du tuteur (le view-model n'en garde que trois), son commentaire, puis le
 * chemin vers tous ses rapports.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Badge } from "../../atoms/Badge"
import { TextButton } from "../../atoms/Buttons/TextButton"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { SettingsSection } from "../../molecules/SettingsSection"
import { countLabel } from "../../../ports/primary/ui/formatters/textFormatter"
import { type UITutorSessionBrief } from "../../../ports/primary/ui/types/tutorEleves"

export type TutorStudentLastSessionCardProps = {
    lastSession: NonNullable<UITutorSessionBrief["lastSession"]>
    /** Le compte de ses rapports, sur le lien. */
    reportsCount?: number
    onOpenReports?: () => void
    testID?: string
}

export function TutorStudentLastSessionCard(props: TutorStudentLastSessionCardProps) {
    const { lastSession, reportsCount, onOpenReports, testID } = props
    return (
        <SettingsSection title={lastSession.label} testID={testID}>
            <Stack gap="2">
                <Row gap="2" align="center" style={styles.wrap}>
                    <Text size="text-sm" color="text-muted">
                        {lastSession.dateLabel}
                    </Text>
                    {lastSession.tags.map((tag) => (
                        <Badge
                            key={tag.label}
                            text={tag.label}
                            variant={tag.tone === "positive" ? "success" : "warning"}
                            tinted
                        />
                    ))}
                </Row>
                {lastSession.comment != null && lastSession.comment !== "" && (
                    <Text size="text-md">{`«\u00a0${lastSession.comment}\u00a0»`}</Text>
                )}
                {onOpenReports != null && (
                    <Row>
                        <TextButton
                            label={reportsCount != null ? `Ses ${countLabel(reportsCount, "rapport")}` : "Ses rapports"}
                            onPress={onOpenReports}
                        />
                    </Row>
                )}
            </Stack>
        </SettingsSection>
    )
}

const styles = StyleSheet.create(() => ({
    wrap: { flexWrap: "wrap" },
}))
